import React from 'react'
import { connect } from 'react-redux'
import Toggle from 'react-toggle'
import SectionActions from '../../Redux/SectionRedux'

class UpdateSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        title_id: props.detail.title_id || '',
        title_en: props.detail.title_en || '',
        status: props.detail.status || ''
      }
    }
  }

  _inputChange = (e, f) => {
    if (e) e.preventDefault()
    let v
    let form = { ...this.state.form }
    if (f !== 'status') {
      v = e.target.value
      form[f] = v
      this.setState({ form })
    } else {
      if (form.status === 'active') {
        form.status = 'inactive'
      } else {
        form.status = 'active'
      }
      this.setState({ form })
    }
  }

  _submit = (e) => {
    if (e) e.preventDefault()
    let form = { ...this.state.form }
    let uuid = this.props.detail.id
    let data = { uuid, form }
    this.props.putSection(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 500)
  }

  render () {
    return (
      <section style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title'>Edit Section</h3>
        </div>
        <form onSubmit={(e) => this._submit(e)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (ID)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_id} className='form-control' placeholder='Input name (id)' onChange={(e) => this._inputChange(e, 'title_id')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Title (EN)</label>
            </div>
            <div className='col-9'>
              <input required value={this.state.form.title_en} className='form-control' placeholder='Input title (en)' onChange={(e) => this._inputChange(e, 'title_en')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Status</label>
            </div>
            <div className='col-9'>
              <Toggle
                checked={this.state.form.status === 'active'}
                name='status'
                onChange={() => this._inputChange(null, 'status')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Submit</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  section: state.section
})

const dispatchToProps = (dispatch) => ({
  putSection: (data) => dispatch(SectionActions.putSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateSection)



// WEBPACK FOOTER //
// ./src/Containers/Section/UpdateSection.js